<template>
	<div>
		<div class="row pl-3 pr-3">
			<div class="col-md-2 col-12 mt-auto mb-auto">
				<h3>Report SSU</h3>
				<!-- <h6>Choose 1 Dealer To Use This Feature</h6> -->
			</div>
			<div class="offset-md-4 col-md-1 col-6 mt-2 wrapHighlight">
				<multiselect
					v-model="parentFilter.filterBy"
					:options="['ssu_date', 'scan_date']"
					:custom-label="opt => toCapitalizedWords(opt)"
					placeholder="Filter By"
					:allow-empty="false"
					class="filter-select"
				></multiselect>
			</div>
			<div class="offset-md-1 col-md-2 col-6 mt-2 wrapHighlight">
				<!-- <label>Period</label> -->
				<flat-pickr
					v-model="selected.date"
					:config="rangeConfig"
					placeholder="Select To Date"
				/>
			</div>
			<!-- <div class=" col-md-3 col-6 mt-2 wrapHighlight">
				<label>SL Dealer Date (Scan)</label>
				<flat-pickr
					v-model="parentFilter.sl_dealer_date_by_scan"
					:config="notRangeConfig"
					placeholder="Select To Date"
				/>
			</div> -->

			<div class="col-md-2 col-6 mt-2 wrapHighlight">
				<button class="btn btn-warning w-100" style="height:43px" @click="downloadExcel"><i class="fa fa-download"></i> Download CSV</button>
			</div>
		</div>


		<vue-universal-table
			class="mt-4 text-center"
			api_url="/api/reports/ssu-kecamatan"
			:filter="parentFilter"
			:update="table.update"
			:fields="table.fields"
		/>

	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
const XLSX = require('xlsx')
import debounce from 'debounce'

import { ToggleButton } from 'vue-js-toggle-button'
import Vue_universal_table from '../../../../components/table/vue_universal_table.vue'


export default {
	components : {
		Multiselect,
		flatPickr,
		ToggleButton
	},
	data () {
		let start = new moment().add('-1' , 'days').format('Y-MM-DD')
		let end = new moment().format('Y-MM-DD')
		return {
			
			filterData : {
				dealer: this.$store.getters.getDealer(null, null),
				ring : ['LOKASI' , 'RING 1' , 'RING 2' , 'RING 3' , 'OTHER' , 'PELANGGARAN WILAYAH'],
			},

			parentFilter : {
				// date : date
				start : start,
				end : end,
				filterBy: 'ssu_date',
				// sl_dealer_date_by_scan : start
			},
			selected : {
				date : `${start} to ${end}`
			},
			rangeConfig : {
				mode : 'range',
				dateFormat : 'Y-m-d',
				altInput : true,
				altInputClass: 'form-control input flatpickr-input',
				altFormat: "j M Y"
			},
			notRangeConfig : {
				dateFormat : 'Y-m-d',
				altInput : true,
				altInputClass: 'form-control input flatpickr-input',
				altFormat: "j M Y"
			},
			urlTarget : {
				dealerRing : {
					url : '/api/reports/crm/sales-by-dealer-ring?',
					filterVar : null,
					requiredFilter : 'dealer'
				},
				ringStatus : {
					url : '/api/reports/crm/sales-by-ring-status?',
					filterVar : 'ringFilter',
					requiredFilter : 'dealer'
				}
			},
			data : null,
			table : {
				update : 0,
				fields : [{
					title : 'Engine No',
					variable : 'engine_no'
				},{
					title : 'SSU Date',
					variable : 'ssu_date',
					date_format : 'MMM DD, Y | HH:mm'
				},{
					title : 'Scan Date',
					variable : 'scan_date',
					date_format : 'MMM DD, Y | HH:mm'
				},{
					title : 'Dealer Code',
					variable : 'kd_dealer'
				},{
					title : 'SSU Kecamatan',
					variable : 'ssu_kecamatan'
				},{
					title : 'Scan Kecamatan',
					variable : 'scan_kecamatan'
				}]
			}
		}
	},
	mounted () {
		// this.loadData()
	},
	watch : {
		// 'parentFilter.sl_dealer_date_by_scan' : function() {
		// 	this.loadData()
		// },
		'selected.date' : function () {
			let splitDate = this.selected.date.split(' to ')
			this.parentFilter.start = splitDate[0]
			this.parentFilter.end = splitDate[1] ? splitDate[1] : splitDate[0]
			this.debounceLoadData();
		}
		// ringFilter : {
		// 	deep : true,
		// 	handler () {
		// 		this.loadData(['ringStatus'])
		// 	}
		// },
	},
	methods : {
		async downloadExcel () {
			try {
				let queryString = this.initialiseFilter('' , this.parentFilter)
				let response = await this.$http.get('/api/reports/download-ssu-kecamatan?' + queryString)
				let data = response.data.data
				let wb = XLSX.utils.book_new()

				let ws2 = XLSX.utils.json_to_sheet(data, {raw:true});
				XLSX.utils.book_append_sheet(wb, ws2, "SSU")

				XLSX.writeFile(wb, `Report SSU - ${this.selected.date}.csv`)
			}
			catch(err) {
				console.log(err)
			}
		},
		async loadData () {
			try {
				this.data = null
				let url = '/api/reports/ssu-kecamatan?'

				url += this.filterBy === 'ssu_date' ? 'filterBy=ssu_date&' : 'filterBy=scan_date&'

				url = this.initialiseFilter(url , this.parentFilter)

				let response = await this.$http.get(url)
				
				let data = response.data.data

				for(var i = 0; i < data.length ; i++) {
					data[i].ssu_date = data[i].ssu_date ? new moment(data[i].ssu_date).format('MMM DD, Y HH:mm') : '-'
					data[i].scan_date = data[i].scan_date ? new moment(data[i].scan_date).format('MMM DD, Y HH:mm') : '-'
				}

				// if(data.length == 0) {
				// 	data.push({
				// 		engine_no : '-',
				// 		frame_no : '-',
				// 		type : '-',
				// 		color : '-',
				// 		shipping_number : '-',
				// 		shipping_date : '-',
				// 		transporter : '-',
				// 		no_license : '-',
				// 		driver : '-',
				// 		warehouse_destination : '-'
				// 	})
				// }

				// this.data = data.map((obj) => ({
				// 	engine_no : obj.engine_no,
				// 	frame_no : obj.frame_no,
				// 	type : obj.type,
				// 	color : obj.color,
				// 	shipping_number : obj.shipping_number,
				// 	shipping_date : obj.shipping_date != '-' ? moment(obj.shipping_date).format('MMM DD, YYYY') : '-',
				// 	transporter : obj.transporter,
				// 	no_license : obj.no_license,
				// 	driver : obj.driver,
				// 	warehouse_destination : obj.warehouse_destination
				// }))
				this.data = data

			}
			catch(e) {
				console.log(e)
			}
		},
		debounceLoadData: debounce(function (e) {
			this.table.update++
		}, 2000)
		// loadData (apiLoader = null) {
		// 	if(!apiLoader) {
		// 		apiLoader = ['dealerRing' , 'ringStatus']
		// 	}
			
		// 	for (var i = 0 ; i < apiLoader.length ; i++) {
		// 		let curApi = this.urlTarget[apiLoader[i]]

		// 		let varTarget = apiLoader[i]
		// 		let url = curApi.url

		// 		if(curApi.requiredFilter && !this.parentFilter[curApi.requiredFilter])
		// 			return

		// 		// console.log(curApi.filterVar)
		// 		url = this.initialiseFilter(url , this.parentFilter)

		// 		if(curApi.filterVar)
		// 			url = this.initialiseFilter(url , this[curApi.filterVar])

		// 		this.$http.get(url)
		// 		.then((resp) => {
		// 			this.data[varTarget] = resp.data.data
		// 		})
		// 		.catch((err) => {
		// 			console.log(err);
		// 		})
		// 	}
		// }
	}
}
</script>

<style scoped>
	.flexify {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.filter-select {
		/* box-shadow: 0px 2px 6px #0000001A; */
        /* background-color: #F36F21 !important; */
        /* padding: 0 40px 0 12px; */
        min-height: 32px;

        /* display: table; */
        width: 240%;
	}
</style>